import { DrawerBody as ChakraDrawerBody } from '@chakra-ui/react'

import { DrawerBodyProps } from './DrawerBodyTypes'

export default function Drawer(props: DrawerBodyProps) {
  return <ChakraDrawerBody {...props} translate="no" />
}
